import { RG_TYPE as I, deepAddParent as M, RgCreate as B, deepFlatChildrenOfType as V, roundDecimals as $ } from "@project-rouge/rg-core";
import { Vector3 as O, MathUtils as k } from "three";
import { deepApplyTransform as F } from "../../geometry-utils/core/index4.js";
import { getLineDirection as H } from "../../geometry-utils/core/index8.js";
import { rotateAroundY as L } from "../../geometry-utils/core/index23.js";
import { getEuler as Y } from "../../geometry-utils/three/index7.js";
import { getPivot as E } from "../../geometry-utils/three/index12.js";
import { distanceToLine as C } from "../../geometry-utils/three/index18.js";
import { V3toVector3 as G } from "../../geometry-utils/index9.js";
import { SignedAngle as S } from "../../utils/index32.js";
import { createRgObjectsOnLines as D } from "../boundary/index.js";
import { getLevelOuterBoundary as K } from "../boundary/index7.js";
const W = new O(), R = new O();
function lo({ building: o, facadeModId: s = void 0, openingDistanceThreshold: l = 0.135, rvDataList: d = [] }) {
  if (o.data.levels.length === 0)
    throw new Error("Fa\xE7ade could not be created, Building has no levels!");
  if (o.children.some((e) => e.type === I.Facade))
    throw new Error("Building already contains fa\xE7ade elements! Fa\xE7ade generation has been cancelled.");
  const c = s ? d.find((e) => e.modulousId === s) : void 0, p = c && c.totalThickness ? c.totalThickness : 0.3, x = new O(1, 0, 0).applyEuler(Y(o)).normalize(), n = o.data.levels.sort((e, t) => e.floorWorldBottom - t.floorWorldBottom), u = /* @__PURE__ */ new Map();
  for (const e of n)
    u.has(e.levelIndex) || u.set(e.levelIndex, []), u.get(e.levelIndex).push(e);
  const P = o.data.levels.filter(({ isPodium: e }) => e);
  let m = n[0];
  if (P) {
    const e = P.slice().sort((g, y) => g.levelIndex - y.levelIndex), t = e[0], a = e[e.length - 1], i = n.indexOf(a) + 1;
    i < n.length ? m = n[i] : m = n[n.indexOf(t) - 1];
  }
  M(o);
  const f = [], h = {};
  for (const e of n)
    _({ level: e, building: o, levelsByIndex: u, templates: h, rvDataList: d, facades: f, podiumProjectionLevel: m, facadeWidth: p, facadeData: c, threshold: l, buildingAxis: x });
  o.children.push(...f);
  const A = o.data.anatomy;
  return o.data.anatomy = A, f;
}
function U(o) {
  return `${o.length}|${o.map((s) => `${s.type}|${s.size[0]}|${s.size[2]}`).join("|")}`;
}
function _({ level: o, building: s, levelsByIndex: l, templates: d, rvDataList: c, facades: p, podiumProjectionLevel: z, facadeWidth: x, facadeData: n, threshold: u, buildingAxis: P }) {
  const m = s.children.filter((r) => r.type !== I.Facade && r.data.levelId === o.uuid);
  let f = 0;
  o.isRoof && (f = o.floorWorldBottom - l.get(o.levelIndex)[0].floorWorldBottom);
  let h = f;
  if (!o.isRoof && l.get(o.levelIndex + 1))
    h += l.get(o.levelIndex + 1)[0].floorWorldBottom - o.floorWorldBottom;
  else {
    const r = m.filter((w) => w.type === I.Parapet), v = Math.max(...r.map((w) => w.pos[1])), T = Math.max(...r.map((w) => w.size[1]));
    h += v - o.floorWorldBottom + T;
  }
  const A = s.pos[1] + o.floorWorldBottom - f, e = U(m);
  if (d[e]) {
    for (const r of d[e]) {
      const v = B({ ...r }, c || []);
      v.size[1] = h, v.pos[1] = A, v.data.level = o.levelIndex, v.data.levelId = o.uuid, p.push(v);
    }
    return;
  }
  const a = m.flatMap((r) => V(r, I.Wall)).flatMap((r) => r.children), i = [0.5, 0, 0.5], g = a.map((r) => F(E(i, r), r)).map(G), y = K(s, o.isPodium ? z : o, x), j = D({
    lines: y,
    thickness: x,
    height: h,
    partial: {
      type: I.Facade,
      modulousId: n ? n.modulousId : "",
      name: "facade",
      data: { level: o.levelIndex, levelId: o.uuid },
      children: []
    },
    rvDataList: c
  });
  d[e] = [];
  for (let r = 0; r < y.length; r++)
    q({
      facade: j[r],
      line: y[r],
      templateList: d[e],
      openings: a,
      openingsPivots: g,
      threshold: u,
      building: s,
      pivot: i,
      rvDataList: c,
      buildingAxis: P,
      facades: p,
      y: A
    });
}
function q({ facade: o, line: s, openings: l, openingsPivots: d, threshold: c, building: p, pivot: z, rvDataList: x, buildingAxis: n, facades: u, templateList: P, y: m }) {
  if ($(o.size[0]) <= 0)
    return;
  const f = H(s);
  W.fromArray(s[0]), R.fromArray(s[1]);
  const h = [];
  for (let t = 0; t < l.length; t++) {
    const a = d[t], { distance: i } = C(a, [W, R], 1);
    i < c && h.push({
      obj: l[t],
      pivot: a,
      line: {
        start: F(E([0, 0, 0.5], l[t]), l[t]),
        end: F(E([1, 0, 0.5], l[t]), l[t])
      }
    });
  }
  o.pos[1] = m;
  for (const t of h) {
    let a = L([t.pivot.toArray()], o.pos, o.rot[1])[0];
    a = L([a], o.pos, p.rot[1])[0];
    const i = B({
      name: "opening",
      children: [],
      type: I.Opening,
      pos: a.map((g, y) => g - o.pos[y]),
      size: [t.obj.size[0], t.obj.size[1], o.size[2]],
      anchor: z,
      rot: [0, 0, 0],
      alpha: 0.5
    }, x);
    i.pos[2] = -i.size[2] * i.anchor[2], o.children.push(i);
  }
  const A = L([o.pos], p.pos, p.rot[1])[0];
  o.pos = A.map((t, a) => t - p.pos[a]), o.rot = [0, -S(f, n) * k.RAD2DEG, 0], u.push(o);
  const e = B({ ...o }, x || []);
  e.pos[1] = 0, e.data.level = -1, P.push(e);
}
export {
  lo as createFacadeFromBoundary
};
//# sourceMappingURL=index.js.map
